export const GAME_MODES = {
	COLUMNS_4: 4,
	COLUMNS_6: 6,
	COLUMNS_8: 8,
	COLUMNS_10: 10,
	ANNOUNCE_AND_COMMAND: 101,
	HANDS: 102,
	FREE: 103,
};

export const GAME_MODE_NAMES = {
	[GAME_MODES.COLUMNS_4]: 'Short game',
	[GAME_MODES.COLUMNS_6]: 'Medium game',
	[GAME_MODES.COLUMNS_8]: 'Long game',
	[GAME_MODES.COLUMNS_10]: 'Extra long',
	[GAME_MODES.ANNOUNCE_AND_COMMAND]: 'Announce and command',
	[GAME_MODES.HANDS]: '4 Hand columns',
	[GAME_MODES.FREE]: '4 free columns',
};

export const GAME_PLAYER_MODE = {
	singlePlayer: 'Play alone',
	multiPlayer: 'Play with a friend',
};
